import React from 'react';
import '../css/Header.css';
import EditableLabel from './EditableLabel';

interface HeaderProps {
  currentPage: 'dashboard' | 'analysis';
  onNavigate: (page: 'dashboard' | 'analysis') => void;
  user?: { username: string; email?: string; role?: string };
  onLogout?: () => void;
  isLoading?: boolean;
}

const Header: React.FC<HeaderProps> = ({ currentPage, onNavigate, user, onLogout }) => {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <div className="app-logo" onClick={() => onNavigate('dashboard')}>
            <svg
              className="logo-icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
            </svg>
            <span>
              <EditableLabel labelKey="header.appName" defaultValue="特許マップ作成システム" />
            </span>
          </div>
          <nav className="header-nav">
            <button
              className={`nav-link dashboard-nav ${currentPage === 'dashboard' ? 'active' : ''}`}
              onClick={() => onNavigate('dashboard')}
            >
              <svg
                className="dashboard-nav-icon"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3 10.5L12 3l9 7.5"></path>
                <path d="M5 9.5V21h14V9.5"></path>
                <path d="M9 21v-7h6v7"></path>
              </svg>
              <EditableLabel labelKey="header.navDashboard" defaultValue="管理画面へ" />
            </button>
          </nav>
        </div>

        <div className="header-right">
          <div className="user-profile">
            <div className="avatar">{user?.username.charAt(0).toUpperCase() || 'U'}</div>
            <span className="user-name">{user?.username || 'ゲスト'}</span>
          </div>
          <button className="logout-btn-text" onClick={onLogout}>
            <EditableLabel labelKey="header.logoutButton" defaultValue="ログアウト" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
